export default __webpack_public_path__ + "media/music/e9fa9599d475092e1cf735b310c691f5.mp3";